import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Collapse, Stack } from '@rossum/ui/material';
import { allMessagesSelector } from '../../../../redux/modules/datapoints/selector';
import { SidebarContainer } from '../../../document-sidebar';
import { useDocumentStore } from '../../document-store/DocumentStore';
import { Messages } from '../sidebar-items/shared/Messages';

const GlobalMessages = React.memo(() => {
  const intl = useIntl();

  const messagesVisible = useDocumentStore(
    state => state.sidebarState.messagesVisible
  );
  const setMessageVisibility = useDocumentStore(
    state => state.sidebarActions.setMessagesVisibility
  );

  const globalMessages = useSelector(allMessagesSelector).all;

  const hasGlobalMessages = !!globalMessages && globalMessages.length > 0;

  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (containerRef.current && messagesVisible) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [messagesVisible]);

  useEffect(() => {
    if (hasGlobalMessages) {
      setMessageVisibility(true);
    }
  }, [hasGlobalMessages, setMessageVisibility]);

  return (
    <Collapse
      in={messagesVisible}
      ref={containerRef}
      sx={{ scrollMarginTop: '150px' }}
    >
      {hasGlobalMessages ? (
        <SidebarContainer
          title={intl.formatMessage({
            id: 'components.sidebarV2.messages.title',
          })}
        >
          <Stack py={1}>
            <Messages messages={globalMessages} />
          </Stack>
        </SidebarContainer>
      ) : (
        <span />
      )}
    </Collapse>
  );
});

GlobalMessages.displayName = 'GlobalMessages';

export { GlobalMessages };
